import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

export const useScrollToTop = () => {
  const navigate = useNavigate();

  const navigateWithScroll = useCallback(
    (to: string, options?: any) => {
      navigate(to, options);
      window.scrollTo(0, 0);
    },
    [navigate]
  );

  const scrollToTop = useCallback(() => {
    window.scrollTo(0, 0);
  }, []);

  return { navigateWithScroll, scrollToTop };
};
